import Vue from 'vue';
import App from './App.vue';
import vuetify from './plugins/vuetify';
import { firestorePlugin } from 'vuefire';
import '@fortawesome/fontawesome-free/css/all.css';
import 'vue2-dropzone/dist/vue2Dropzone.min.css';
import router from './router';
import VueTheMask from 'vue-the-mask';
import FlagIcon from 'vue-flag-icon';
import VueExpandableImage from 'vue-expandable-image';

import util from './plugins/utils';
import constants from './domain/enums/AppConstants.js';
import mensagens from './domain/enums/Mensagens.js';
import eventBus from './event-Bus.js';
import http from './http-common.js';
import modalidades from './domain/enums/Modalidades.js';

Vue.use(require('vue-moment'));
Vue.use(FlagIcon);
Vue.use(VueTheMask);
Vue.use(VueExpandableImage);
Vue.use(firestorePlugin);
Vue.config.productionTip = false;

// cria uma propriedade global de métodos utilitários.
Vue.prototype.$utils = util;
// cria uma propriedade globas para emissor de eventos da aplicação.
Vue.prototype.$eventBus = eventBus;
// cria uma propriedade global de constantes da aplicação.
Vue.prototype.$const = constants;
// cria uma propriedade global de constantes de mensagens da aplicação.
Vue.prototype.$msg = mensagens;
// Substitui o uso do Vue Resource, na propriedade global http, pela biblioteca Axios.
Vue.prototype.$http = http;
Vue.prototype.$modalidades = modalidades;

new Vue({
  vuetify,
  router,
  drawer: null,
  render: (h) => h(App),
}).$mount('#app');
